import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "60",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      "fill-opacity": ".3",
      d: "M0 12C0 5.373 5.373 0 12 0h36c6.627 0 12 5.373 12 12s-5.373 12-12 12H12C5.373 24 0 18.627 0 12"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "13.783",
      cy: "12",
      r: "2.297",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "13.784",
      cy: "12",
      r: "5.942",
      stroke: "#fff",
      "stroke-width": ".983"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M32.008 17.309c2.043 0 3.543-1.222 3.538-2.883.005-1.266-.762-2.174-2.091-2.38v-.078c1.046-.269 1.725-1.09 1.72-2.213.005-1.471-1.202-2.727-3.127-2.727-1.838 0-3.313 1.11-3.362 2.737h1.46c.035-.92.9-1.476 1.882-1.476 1.021 0 1.69.62 1.686 1.544.005.967-.772 1.603-1.881 1.603h-.846v1.23h.846c1.387 0 2.189.704 2.189 1.711 0 .972-.846 1.632-2.023 1.632-1.085 0-1.93-.557-1.989-1.446h-1.534c.063 1.632 1.51 2.746 3.532 2.746m8.879 0c2.09.02 3.479-1.486 3.474-3.406.005-1.915-1.388-3.288-3.122-3.288-1.056 0-1.97.508-2.483 1.353h-.073c.005-2.272.865-3.62 2.33-3.62.963 0 1.57.586 1.774 1.417h1.49c-.229-1.584-1.475-2.737-3.263-2.737-2.326 0-3.777 1.999-3.777 5.478-.005 3.684 1.871 4.788 3.65 4.803m-.005-1.27c-1.163 0-2.013-.978-2.013-2.102.005-1.119.894-2.096 2.047-2.096 1.143 0 1.984.924 1.979 2.082.005 1.182-.87 2.115-2.013 2.115m8.742 1.299c2.311 0 3.665-1.886 3.665-5.165 0-3.254-1.373-5.145-3.665-5.145-2.296 0-3.664 1.886-3.67 5.145 0 3.274 1.354 5.16 3.67 5.165m0-1.305c-1.353 0-2.17-1.358-2.17-3.86.006-2.492.822-3.865 2.17-3.865 1.344 0 2.165 1.373 2.165 3.865 0 2.502-.816 3.86-2.165 3.86"
    }, null, -1)
  ]))]))
}
export default { render: render }